import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
//importing data
import servicesData from '../../data/servicesData';
import Service from './Service';

function ServicesSection() {
    // const [services, setServices] = useState(servicesData())
    let services = servicesData();
    console.log(services)
    return (
        <section className="services">
            <Title>
                <p>Our Services</p>
                <h2>You can take advantage of our various services</h2>
            </Title>
            {/* <div className="service service__one"> */}
            <div className="services__items">
                {services.map((service) => (
                    <Service
                        service={service}
                    />
                ))}
            </div>
            <div className="services__button">
                <Link to="/services">Find Out More..</Link>
            </div>
        </section>
    )
}

export default ServicesSection


const Title = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 0rem;
    p{
      color: #e21f36;
      font-weight: 600;
      font-size: 1rem;
      
      /* background-color: yellow; */
    }
    h2{
      color: #000219;
      font-weight: 800;
      font-size: 2rem;
      text-transform: capitalize;
      padding: 0rem 0.5rem;
      /* background-color: yellow; */
    }
`